<template>
  <div class="box-border border-left-top" :style="{'max-height':tableHeight,overflow:'auto'}">
    <div class="col-header flex relative">
      <table border='1' cellspacing='0' cellpadding="0">  
      <!-- 列头 -->
        <tr>
          <td height="44" align="left" class="stick-one" :style="{width:tdWidth}">
            <div class="flex items-center" @click="clickColSort(-1,{name:'指标'})">
              <span>{{selectDimension == 'area' ? '指标' : '地区'}}</span>
              <div class="flex flex-col justify-center">
                <i class="el-icon-caret-top text-theme-black-350" :class="['指标' == curTime ? (sort == 'up'?'activeSort' : '') : '']"></i>
                <i class="el-icon-caret-bottom text-theme-black-350 inline-block -mt-2" :class="['指标' == curTime ? (sort == 'down'?'activeSort' : '') : '']"></i>
              </div>
            </div>
          </td>
          <td v-for="(item,index) in checkColArr" :key="item.name" height="44" align="left" class="stick-col-head" :style="{width:tdWidth}">
            <div class="flex items-center" @click="clickColSort(index,item)">
              <span>{{item.name}}</span>
              <div class="flex flex-col justify-center">
                <i class="el-icon-caret-top text-theme-black-350" :class="[item.name == curTime ? (sort == 'up'?'activeSort' : '') : '']"></i>
                <i class="el-icon-caret-bottom text-theme-black-350 inline-block -mt-2" :class="[item.name == curTime ? (sort == 'down'?'activeSort' : '') : '']"></i>
              </div>
            </div>
          </td>
        </tr>
        <!-- 列选择框 -->
        <tr class="left-right-border" v-if="chartType != 'table'">
          <td height="44" class="noborder stick-row-head" :style="{width:tdWidth,'background-color': '#f5f5f5'}"></td>
          <td height="44" align="left" class="noborder" v-for="(item,index) in checkColArr" :key="index" :style="{width:tdWidth}">
            <template v-if="chartType == 'bar' || (chartType == 'pie' && selectWay == 'row')">
              <el-checkbox v-model="item.check" @change="changeColCheck($event,index)"></el-checkbox>
            </template>
            <template v-else>
              <el-radio v-model="radio" :label="index" @input="inputColwRadio($event,index)">{{''}}</el-radio>
            </template>
          </td>
        </tr>
        <tr v-for="(item,index) in checkRowArr" :key="index">
          <!-- 行头 -->
          <td height="44" align="left" class="stick-row-head" :style="{width:tdWidth}">
            <template v-if="chartType != 'table'">
              <template v-if="chartType == 'bar' || (chartType == 'pie' && selectWay == 'col')">
                <el-checkbox v-model="item.check" @change="changeRowCheck($event,index)"></el-checkbox>
              </template>
              <template v-else>
                <el-radio v-model="radio" :label="index" @input="inputRowRadio($event,index)">{{''}}</el-radio>
              </template>
            </template>
            <span>{{item.name}}</span>
          </td>
          <!-- 展示数据 -->
          <td height="44" align="left" v-for="(item,index1) in data[index]" :key="index1" :style="{width:tdWidth}">{{item}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatisticalTables',
  data() {
    return {
      // selectWay: 'row', //选择行row 列col
      // chartType: 'bar', //图表类型 柱状图 bar 饼图 pie
      timeType: 'quarter',//quarter季度 year 年度
      checkColArr:[],
      checkRowArr: [],
      radio: 0,
      chartData: {
        colData: [],
        rowData: [],
        cellData: []
      },
      sort: '',
      curTime: '',
      lastTime: ''
    }
  },
  props: {
    chartType: String,
    selectWay: String,
    tableData: Object,
    selectDimension: {
      type: String,
      default: 'area'
    },
  },
  computed: {
    tdWidth() {
      let len = this.checkColArr.length
      if(len < 10){
        return `calc((100vw - 294px)/${len+1})`
      }else{
        return '153px'
      }
    },
    tableHeight() {
      if(this.chartType == 'table') {
        return 'calc(100vh - 194px)'
      }else if(this.chartType == 'bar'){
        // 'calc(100vh - 572px)'
        return 'fit-content'
      }else{
        return 'fit-content'
      }
    }
  },
  watch: {
    chartType() {
      this.initCheckParams()
      this.getChartData()
    },
    selectWay() {
      this.initCheckParams()
      this.getChartData()
    },
    tableData: {
      handler(v){
        this.data = this.tableData.data
        this.checkColArr = this.tableData.colHeaders
        this.checkRowArr = this.tableData.rowHeaders
        this.initCheckParams()
        this.getChartData()
      },
      deep: true
    }
  },
  mounted() {
    this.data = this.tableData.data
    this.checkColArr = this.tableData.colHeaders
    this.checkRowArr = this.tableData.rowHeaders
    this.initCheckParams()
    this.getChartData()
  },
  methods: {
    changeColCheck(e,index){
      this.checkColArr[index].check = e
      this.$forceUpdate()
      this.getChartData()
    },
    changeRowCheck(e,index){
      this.checkRowArr[index].check = e
      this.$forceUpdate()
      this.getChartData()
    },
    inputRowRadio(e,index){
      this.checkRowArr.forEach((item,itemindex) => {
        item.check = itemindex  == index
      })
      this.$forceUpdate()
      this.getChartData()
    },
    inputColwRadio(e,index){
      this.checkColArr.forEach((item, itemindex) => {
          item.check = itemindex  == index
      })
      this.$forceUpdate()
      this.getChartData()
    },
    initCheckParams(){
      if(this.chartType == 'bar'){
        this.checkColArr.forEach((item, index) => {
            item.check = index < 4
        })
        this.checkRowArr.forEach((item,index) => {
          item.check = index < 4
        })
      }else if(this.chartType == 'pie'){
        if(this.selectWay == 'row'){
          this.checkColArr.forEach((item, index) => {
            item.check = index < 4
          })
          this.checkRowArr.forEach((item,index) => {
            item.check = index == 0
          })
          this.radio = 0
        }else if(this.selectWay == 'col') {
          this.checkColArr.forEach((item, index) => {
            item.check = index == 0
          })
          this.checkRowArr.forEach((item,index) => {
            item.check = index < 4
          })
          this.radio = 0
        }
      }
      this.$forceUpdate()
    },
    getChartData(){
      let colData = []
      let rowData = []
      let cellData = []
      this.checkColArr?.forEach((item,index) => {
        item.indexVal = index
        if(item.check) colData.push(item)
      })
      this.checkRowArr?.forEach((item,index) => {
        item.indexVal = index
        if(item.check) rowData.push(item)
      })
      if(rowData.length < 1 || colData.length < 1) {
        this.chartData = {
          colData: [],
          rowData: [],
          cellData: []
        }
      } else {
        if(this.selectWay == 'row'){
          rowData.forEach((row,rowIndex) => {
            let rowArr = []
            colData.forEach((col,colIndex) => {
              rowArr.push(this.data[row.indexVal][col.indexVal])
            })
            cellData.push(rowArr)
          })
        }else{
          colData.forEach((col,rowIndex) => {
            let colArr = []
            rowData.forEach((row,colIndex) => {
              colArr.push(this.data[row.indexVal][col.indexVal])
            })
            cellData.push(colArr)
          })
        }
        
        this.chartData = {
          colData,
          rowData,
          cellData
        }
      }
      this.$emit('update:chartData',this.chartData)
    },
    clickColSort(index,data){
      this.curTime = data.name
      if(this.lastTime == this.curTime){
        if(this.sort == '') {
          this.sort = 'up'
        }else if(this.sort == 'up'){
          this.sort = 'down'
        }else{
          this.sort = ''
        }
      }else{
        this.sort = 'up'
      }
      this.lastTime = this.curTime
      if(this.sort){
        this.$parent.queryTableDataOrder(index,this.sort)
      }else{
        this.$parent.queryTableData(index,this.sort)
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
.el-radio{
  margin-right: 0 !important;
}
.el-checkbox{
  margin-right: 8px !important;
}
.border-left-top{
  border: 1px solid #e7e9eb;
}
.col-header{
  width: calc(100vw - 297px);
  // max-height: calc(100vh - 248px);
  // overflow-x: auto;
}
table{
  border-color:#e7e9eb;
  border-collapse: collapse;  
  background-color: #f5f5f5;
}
table tr td:first-child{
  border-left: 0;
}
table tr td:last-child{
  border-right: 0;
}
table tr:first-child td{
  border-top: 0;
}
table tr:last-child td{
  border-bottom: 0;
}
td {
  border: 1px solid #e7e9eb;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  min-width: 153px;
  background-color: #fff;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  padding-left: 16px;
  box-sizing: border-box;
}
.stick-col-head{
  position: sticky;
  top: 0;
  left: 144px;
  background-color: #f5f5f5;
}
.stick-row-head{
  position: sticky;
  left: 0;
  top: 44px;
  background-color: #f5f5f5;
  z-index: 99;
}
.stick-one{
  background-color: #f5f5f5;
  position: sticky;
  left: 0;
  top: 0;
}
.noborder{
  // border: none;
}
.left-right-border{
  border-left: 1px solid #e7e9eb;
  border-right: 1px solid #e7e9eb;
}
.activeSort{
  @apply text-theme;
}
</style>